// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-section {
    background-color: #313131;
}
.footer-container {
    padding: 40px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    color: white;
    border-bottom: 2px solid #293241;
    border-radius: 2px;
}
/* Title */
.footer-col1 img{
    margin: 16px 0;
    margin-right: auto;
    margin-left: auto;
    display:flex;
    justify-content: center;
    width: 200px;
    height: 120px;
    top: 80px;
    left: 105px
}


.ft-input {
    width: 300px;
    margin: 20px 8px 0 0;
    padding: 16px 22px;
    color: white;
    background-color: #293241;
    border: 1px solid transparent;
    border-radius: 50px;
    outline: transparent;
    font-family: 'Inter', sans-serif;
    font-size: 18px;
    letter-spacing: .8px;
}
.ft-btn {
    padding: 14px 18px;
    color: white;
    border: 2px solid transparent;
    border-radius: 50px;
    outline: transparent;
    background-color: #2e5288;
    font-size: 18px;
    font-family: 'Inter', sans-serif;
    letter-spacing: .8px;
    cursor: pointer;
    transition: all .4s ease;
}
.ft-btn:hover {
    color: #2e5288;
    background-color: white;
    border: 2px solid #2e5288;
}
/* Lists */
.ft-list-title {
    margin: 16px 0;
    font-family: 'Inter', sans-serif;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: .8px;
}
.ft-list-items {
    list-style-type: none;
}
.ft-list-items li a {
    text-decoration: none;
    color: #a5a7ac;
    padding: 0 0 2px 0;
    border-bottom: 2px dotted transparent;
    transition: border .2s ease;
}
.ft-list-items li {
    margin: 24px 0;
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: .8px;
}
.ft-list-items li a:hover {
    border-bottom: 2px dotted #a5a7ac;
}
/* CopyRight */
.ft-copyright {
    padding: 24px 40px;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #cd3c3f;
}

.ft-copyright p {
    color: #fff;
    font-weight: 300;
    text-transform: capitalize;
    font-size: 1.15rem;
    font-family: "Inter", sans-serif;
    margin-top: 0;
}

.ft-copyright a{
    color: white;
    text-decoration: underline;
}


.ft-social-links {
    list-style-type: none;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
}

.ft-copyright .social-link-wrapper {
    position: relative;
}

.ft-copyright .social-link-wrapper::before {
    content: "";
    position: absolute;
    bottom: -10px;
    right: -40px;
    left: -50px;
    top: -50px;
    border-bottom: 80px solid #2e5288;
    border-right: 0px solid transparent;
    border-left: 40px solid transparent;
    border-top: 0 solid transparent;
}


.ft-social-links li a {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid #2e5288;
    border-radius: 50%;
    cursor: pointer;
    background: #f5f4f4;;
    position: relative;
}
.ft-social-links li a svg {
    width: 24px;
    height: 24px;
    padding: 1px;

}
.ft-social-links li a svg path {
    fill: #2e5288;

}

/* Responsive */
@media screen and (max-width: 700px) {
    .footer-container {
        padding: 24px;
    }

    .ft-copyright {
        padding: 18px;
        display: block;
        text-align: center;
    }
    .ft-social-links {
        margin: 16px 0 0;
    }

    .ft-copyright .social-link-wrapper::before {
        display: none;

    }


}
`, "",{"version":3,"sources":["webpack://./src/Styles/Footer.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;AACtB;AACA,UAAU;AACV;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,SAAS;IACT;AACJ;;;AAGA;IACI,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;IACzB,eAAe;IACf,gCAAgC;IAChC,oBAAoB;IACpB,eAAe;IACf,wBAAwB;AAC5B;AACA;IACI,cAAc;IACd,uBAAuB;IACvB,yBAAyB;AAC7B;AACA,UAAU;AACV;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,qCAAqC;IACrC,2BAA2B;AAC/B;AACA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,iCAAiC;AACrC;AACA,cAAc;AACd;IACI,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;;AAGA;IACI,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,WAAW;IACX,UAAU;IACV,iCAAiC;IACjC,mCAAmC;IACnC,mCAAmC;IACnC,+BAA+B;AACnC;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;;AAEhB;AACA;IACI,aAAa;;AAEjB;;AAEA,eAAe;AACf;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,cAAc;QACd,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;;IAEjB;;;AAGJ","sourcesContent":[".footer-section {\n    background-color: #313131;\n}\n.footer-container {\n    padding: 40px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 12px;\n    color: white;\n    border-bottom: 2px solid #293241;\n    border-radius: 2px;\n}\n/* Title */\n.footer-col1 img{\n    margin: 16px 0;\n    margin-right: auto;\n    margin-left: auto;\n    display:flex;\n    justify-content: center;\n    width: 200px;\n    height: 120px;\n    top: 80px;\n    left: 105px\n}\n\n\n.ft-input {\n    width: 300px;\n    margin: 20px 8px 0 0;\n    padding: 16px 22px;\n    color: white;\n    background-color: #293241;\n    border: 1px solid transparent;\n    border-radius: 50px;\n    outline: transparent;\n    font-family: 'Inter', sans-serif;\n    font-size: 18px;\n    letter-spacing: .8px;\n}\n.ft-btn {\n    padding: 14px 18px;\n    color: white;\n    border: 2px solid transparent;\n    border-radius: 50px;\n    outline: transparent;\n    background-color: #2e5288;\n    font-size: 18px;\n    font-family: 'Inter', sans-serif;\n    letter-spacing: .8px;\n    cursor: pointer;\n    transition: all .4s ease;\n}\n.ft-btn:hover {\n    color: #2e5288;\n    background-color: white;\n    border: 2px solid #2e5288;\n}\n/* Lists */\n.ft-list-title {\n    margin: 16px 0;\n    font-family: 'Inter', sans-serif;\n    font-size: 24px;\n    font-weight: bold;\n    letter-spacing: .8px;\n}\n.ft-list-items {\n    list-style-type: none;\n}\n.ft-list-items li a {\n    text-decoration: none;\n    color: #a5a7ac;\n    padding: 0 0 2px 0;\n    border-bottom: 2px dotted transparent;\n    transition: border .2s ease;\n}\n.ft-list-items li {\n    margin: 24px 0;\n    font-family: 'Inter', sans-serif;\n    font-size: 16px;\n    font-weight: bold;\n    letter-spacing: .8px;\n}\n.ft-list-items li a:hover {\n    border-bottom: 2px dotted #a5a7ac;\n}\n/* CopyRight */\n.ft-copyright {\n    padding: 24px 40px;\n    padding-top: 0.625rem;\n    padding-bottom: 0.625rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: #cd3c3f;\n}\n\n.ft-copyright p {\n    color: #fff;\n    font-weight: 300;\n    text-transform: capitalize;\n    font-size: 1.15rem;\n    font-family: \"Inter\", sans-serif;\n    margin-top: 0;\n}\n\n.ft-copyright a{\n    color: white;\n    text-decoration: underline;\n}\n\n\n.ft-social-links {\n    list-style-type: none;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 12px;\n}\n\n.ft-copyright .social-link-wrapper {\n    position: relative;\n}\n\n.ft-copyright .social-link-wrapper::before {\n    content: \"\";\n    position: absolute;\n    bottom: -10px;\n    right: -40px;\n    left: -50px;\n    top: -50px;\n    border-bottom: 80px solid #2e5288;\n    border-right: 0px solid transparent;\n    border-left: 40px solid transparent;\n    border-top: 0 solid transparent;\n}\n\n\n.ft-social-links li a {\n    width: 40px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 2px solid #2e5288;\n    border-radius: 50%;\n    cursor: pointer;\n    background: #f5f4f4;;\n    position: relative;\n}\n.ft-social-links li a svg {\n    width: 24px;\n    height: 24px;\n    padding: 1px;\n\n}\n.ft-social-links li a svg path {\n    fill: #2e5288;\n\n}\n\n/* Responsive */\n@media screen and (max-width: 700px) {\n    .footer-container {\n        padding: 24px;\n    }\n\n    .ft-copyright {\n        padding: 18px;\n        display: block;\n        text-align: center;\n    }\n    .ft-social-links {\n        margin: 16px 0 0;\n    }\n\n    .ft-copyright .social-link-wrapper::before {\n        display: none;\n\n    }\n\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
